import React from 'react'
import { useHistory } from 'react-router'
import BulletPoint from '../../../../components/bulletPoint/BulletPoint'

import Button from '../../../../components/button/Button'

import './PricingCard.scss'

const PricingCard = ({ data }) => {
  let history = useHistory()

  const pushPage = () => {
    history.push({
      pathname: '/pay',
      state: { type: data.type, subtype: data.subtype },
    })
  }
  return (
    <div className="PricingCard">
      <div className="PricingCard__wrapper">
        <div className="PricingCard__wrapper__colorColumn" />
        <div className="PricingCard__wrapper__body">
          <div className="pricingCardHeader">{data.title}</div>
          <div className="pricingCardSubHeader">{data.subTitle}</div>
          <div className="pricingCardLowerBody">
            <ul className="pricingCardLeft">
              {data.features.map((item, index) => (
                <BulletPoint key={index} type="regular" item={item} />
              ))}
            </ul>
            <div className="pricingCardRight">
              <div className="top">
                <div className="pricingCardPrice">{data.price}</div>
                <div className="pricingCardDuration">{data.duration}</div>
              </div>
              <div className="pricingCardButton">
                <Button text="Start Now" type="primary" onclick={pushPage} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PricingCard
